import styled from "styled-components";
import { BorderRadiusTheme, ButtonTheme, ColorTheme, SpacingTheme, TextTheme } from "../../globaStyledComponents/globalStyledComponentsStyling";

// Styling for search listing page
interface MobileNavbarWrapperProps {
    hide: boolean | undefined | null;
    location: string;
}

export const MobileNavbarWrapperGuest = styled.div<MobileNavbarWrapperProps>`
    width: 100%;
    bottom: 0;
    position: fixed;
    z-index: 101;
    height: calc(env(safe-area-inset-bottom) + 65px) !important;
    transition: transform 0.3s ease-in-out;
    transform: ${(props) => (props.hide && props.hide != null ? "translateY(100%)" : "none")};
    user-select: none;
    border-top: ${(props) => (props.location === "/" ? "1px solid transparent" : `1px solid ${ColorTheme.Grey3.color}`)};
    background: ${(props) => (props.location === "/" ? "transparent" : "rgba(255, 255, 255, 0.85)")};
    backdrop-filter: ${(props) => (props.location === "/" ? "none" : "blur(28px)")};

    @media (min-width: 768px) {
        display: none;
    }
`;

export const MobileNavbarWrapperHost = styled.div<MobileNavbarWrapperProps>`
    width: 320px;
    bottom: 16px;
    left: 50%;
    transform: ${(props) => (props.hide && props.hide != null ? "translate(-50%, calc(100% + 16px))" : "translateX(-50%)")};
    position: fixed;
    z-index: 101;
    height: calc(env(safe-area-inset-bottom) + 65px) !important;
    transition: transform 0.3s ease-in-out;
    border-radius: 32px;
    user-select: none;
    border: 1px solid ${ColorTheme.White.color};
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(8px);
    // margin: 0 20px;

    @media (min-width: 768px) {
        display: none;
    }
`;

export const MobileNavbarMenuWrapper = styled.div`
    width: calc(100% - 16px);
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    justify-content: space-between;
    margin-top: 20px;
`;

export const MobileNavbarMenuWrapperGuest = styled.div`
    width: calc(100% - 16px);
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    justify-content: space-between;
    margin-top: 20px;
`;

export const MobileNavbarMenuWrapperHost = styled.div`
    width: calc(100% - 16px);
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    justify-content: space-between;
    margin-top: 20px;
`;

export const MobileNavbarMenuWrapperNotLoggedIn = styled.div`
    width: calc(100% - 16px);
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    justify-content: space-between;
    margin: 0 auto;
    height: 100%;
    margin-top: 20px;
`;

export const MobileNavbarMenuWrapperNotLoggedInIcon = styled.img`
    height: 24px;
    width: 24px;
    object-fit: cover;
    border-radius: 50%;
`;

interface MobileNavbarMenuItemProps {
    stroke?: string;
}

export const MobileNavbarMenuItem = styled.button<MobileNavbarMenuItemProps>`
    width: 100%;
    height: 100%;
    min-width: 60px;
    grid-row: 1/2;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    cursor: pointer;
    border: none;
    padding: 0;

    svg {
        height: 24px;
        width: 24px;
        g {
            fill: ${(props) => props.stroke};
        }
        path {
            stroke: ${(props) => props.stroke};
        }
    }
`;

export const MobileNavbarMenuItemGuest = styled.button<MobileNavbarMenuItemProps>`
    width: 100%;
    height: 100%;
    min-width: 60px;
    grid-row: 1/2;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    cursor: pointer;
    border: none;
    padding: 0;

    svg {
        height: 24px;
        width: 24px;
        g {
            fill: ${(props) => props.stroke};
        }
        path {
            stroke: ${(props) => props.stroke};
        }
    }
`;

export const MobileNavbarMenuItemHost = styled.button<MobileNavbarMenuItemProps>`
    width: 100%;
    height: 100%;
    min-width: 60px;
    grid-row: 1/2;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    cursor: pointer;
    border: none;
    padding: 0;

    svg {
        height: 24px;
        width: 24px;
        g {
            fill: ${(props) => props.stroke};
        }
        path {
            stroke: ${(props) => props.stroke};
        }
    }
`;

interface MobileNavbarMenuItemLogInProps {
    stroke: string;
}

export const MobileNavbarMenuItemLogIn = styled.button<MobileNavbarMenuItemLogInProps>`
    width: 60px;
    height: 100%;
    min-width: 60px;
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: center;
    background: none;
    cursor: pointer;
    border: none;

    svg {
        height: 24px;
        width: 24px;
        g {
            fill: ${(props) => props.stroke};
        }
        path {
            stroke: ${(props) => props.stroke};
        }
    }
`;

export const MobileNavbarMenuItemLogInGuest = styled.button<MobileNavbarMenuItemLogInProps>`
    width: 60px;
    height: 100%;
    min-width: 60px;
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: center;
    background: none;
    cursor: pointer;
    border: none;

    svg {
        height: 24px;
        width: 24px;
        g {
            fill: ${(props) => props.stroke};
        }
        path {
            stroke: ${(props) => props.stroke};
        }
    }
`;

export const MobileNavbarMenuItemLogInHost = styled.button<MobileNavbarMenuItemLogInProps>`
    width: 60px;
    height: 100%;
    min-width: 60px;
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: center;
    background: none;
    cursor: pointer;
    border: none;

    svg {
        height: 24px;
        width: 24px;
        g {
            fill: ${(props) => props.stroke};
        }
        path {
            stroke: ${(props) => props.stroke};
        }
    }
`;

export const MobileNavbarMenuItemText = styled.p`
    text-align: center;
    margin: 0;
    margin-top: 6px;
    font-size: ${TextTheme.sans_100.fontSize};
    line-height: ${TextTheme.sans_100.lineHeight};
    font-family: ${(props) => props.color === ColorTheme.Black.color ? TextTheme.sans_100_semi.fontFamily : TextTheme.sans_100.fontFamily};
    color: ${(props) => props.color};
`;

export const MobileNavbarMenuItemTextGuest = styled.p`
    text-align: center;
    margin: 0;
    margin-top: 6px;
    font-size: ${TextTheme.sans_100.fontSize};
    line-height: ${TextTheme.sans_100.lineHeight};
    font-family: ${(props) => props.color === ColorTheme.Black.color ? TextTheme.sans_100_semi.fontFamily : TextTheme.sans_100.fontFamily};
    color: ${(props) => props.color};
`;

export const MobileNavbarMenuItemTextHost = styled.p`
    text-align: center;
    margin: 0;
    margin-top: 6px;
    font-size: ${TextTheme.sans_100.fontSize};
    line-height: ${TextTheme.sans_100.lineHeight};
    font-family: ${(props) => props.color === ColorTheme.Black.color ? TextTheme.sans_100_semi.fontFamily : TextTheme.sans_100.fontFamily};
    color: ${(props) => props.color};
`;

export const MobileNavbarMenuSVG = styled.svg`
    height: 24px;
    width: 24px;
    object-fit: cover;
    border: none;
`;

export const MobileNavbarMenuSVGGuest = styled.svg`
    height: 24px;
    width: 24px;
    object-fit: cover;
    border: none;
`;

export const MobileNavbarMenuSVGHost = styled.svg`
    height: 24px;
    width: 24px;
    object-fit: cover;
    border: none;
`;

interface MobileNavbarProfilePictureWrapperProps {
    selected: boolean;
}

export const MobileNavbarProfilePictureWrapper = styled.div<MobileNavbarProfilePictureWrapperProps>`
    box-sizing: border-box;
    height: 24px;
    width: 24px;
    border-radius: 50%;
    /* ${(props) => (props.selected ? "box-shadow: 0px 0px 0px 1px #FFFFFF, 0px 0px 0px 2px #262626" : "")}; */
`;

export const MobileNavbarProfilePictureWrapperGuest = styled.div<MobileNavbarProfilePictureWrapperProps>`
    box-sizing: border-box;
    height: 24px;
    width: 24px;
    border-radius: 50%;
    /* ${(props) => (props.selected ? "box-shadow: 0px 0px 0px 1px #FFFFFF, 0px 0px 0px 2px #262626" : "")}; */
`;

export const MobileNavbarProfilePictureWrapperHost = styled.div<MobileNavbarProfilePictureWrapperProps>`
    box-sizing: border-box;
    height: 24px;
    width: 24px;
    border-radius: 50%;
    /* ${(props) => (props.selected ? "box-shadow: 0px 0px 0px 1px #FFFFFF, 0px 0px 0px 2px #262626" : "")}; */
`;

export const MobileNavbarProfilePicture = styled.img`
    height: 100%;
    width: 100%;
    border-radius: 50%;
    object-fit: cover;
`;

export const MobileNavbarProfilePictureGuest = styled.img`
    height: 100%;
    width: 100%;
    border-radius: 50%;
    object-fit: cover;
`;

export const MobileNavbarProfilePictureHost = styled.img`
    height: 100%;
    width: 100%;
    border-radius: 50%;
    object-fit: cover;
`;
